import { motion } from "framer-motion";
import { services } from "../data/site";

export default function Services() {
    return (
        <section
            id="services"
            className="relative bg-[#0b0b0b] pt-24 md:pt-32 pb-16 md:pb-20 px-6 md:px-10"
            data-testid="services-section"
        >
            <div className="mx-auto max-w-[1440px]">
                <div className="flex items-center gap-6 mb-10">
                    <span className="w-16 h-px bg-[#C89B3C]" />
                    <span className="text-[10px] uppercase tracking-[0.4em] text-[#C89B3C]">
                        Chapter 07 — Discipline
                    </span>
                </div>

                <div className="grid grid-cols-12 gap-6 items-end mb-16">
                    <motion.h2
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 0.9 }}
                        className="col-span-12 lg:col-span-8 font-display font-light text-white text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
                    >
                        What we <em className="text-[#E2C56D]">build.</em>
                    </motion.h2>
                    <motion.p
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 0.9, delay: 0.15 }}
                        className="col-span-12 lg:col-span-4 text-[#bebebe] text-base leading-relaxed font-light"
                    >
                        Six disciplines, one philosophy — every project handled end-to-end by
                        a team that treats every square foot as its own signature.
                    </motion.p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-[rgba(212,175,55,0.2)]">
                    {services.map((s, i) => (
                        <motion.article
                            key={s.n}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-15%" }}
                            transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
                            className={`group relative p-8 md:p-10 border-b border-[rgba(212,175,55,0.2)] ${
                                (i + 1) % 3 !== 0
                                    ? "lg:border-r lg:border-[rgba(212,175,55,0.2)]"
                                    : ""
                            } ${
                                i % 2 === 0 ? "md:border-r md:border-[rgba(212,175,55,0.2)]" : ""
                            } hover:bg-[#111111] transition-colors duration-500`}
                            data-testid={`service-${i}`}
                        >
                            <div className="flex items-start justify-between mb-8">
                                <span className="font-display text-[#C89B3C] text-2xl">{s.n}</span>
                                <span className="text-[10px] uppercase tracking-[0.35em] text-[#7a7a7a] group-hover:text-[#E2C56D] transition-colors">
                                    Service
                                </span>
                            </div>
                            <h3 className="font-display font-light text-white text-2xl md:text-3xl leading-tight tracking-tight group-hover:text-[#E2C56D] transition-colors">
                                {s.title}
                            </h3>
                            <p className="mt-5 text-[#bebebe] text-sm md:text-base leading-relaxed font-light">
                                {s.body}
                            </p>

                            <div className="mt-10 flex items-center justify-between">
                                <a
                                    href="#contact"
                                    className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-white/85 group-hover:text-[#E2C56D] transition-colors"
                                    data-testid={`service-cta-${i}`}
                                >
                                    Enquire
                                    <span className="w-8 h-px bg-[#C89B3C] group-hover:w-14 transition-[width] duration-500" />
                                </a>
                                <span className="text-[#C89B3C]/60 group-hover:text-[#E2C56D] transition-colors">
                                    ◆
                                </span>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
